<template>
    <div :style="injectCSSVariable()">
        <question :text="$t(item.text)" />
        <div class="matrix-choice__md">
            <b-row align-h="center">
                <b-col cols="12">
                    <div class="d-flex justify-content-center">
                        <div class="matrix-choice__row-label">
                        
                        </div>
                        <div class="d-flex mb-4  w-100">
                            <div 
                                class="matrix-choice__option-label text-center"
                                v-for="(option, i) in selectOptions"
                                :key="'option-text-'+i"
                                :style="{ width: `${100/selectOptions.length}%`}"
                            >
                                {{ option.text }}
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row align-h="center">
                <b-col cols="12">
                    <div 
                        class="matrix-choice__row d-flex justify-content-center align-items-center mb-3"
                        v-for="(choice, i) in choices"
                        :key="'choice-form-'+i"
                    >

                        <div class="matrix-choice__row-label">
                            {{ $t(choice.text) }}
                        </div>
                        <b-form-group class="mb-0 w-100">
                            <b-form-radio-group
                                class="d-flex"
                                v-model="selected[i]"
                                size="lg"
                            >
                                <b-form-radio
                                    v-for="(option, i) in selectOptions"
                                    :value="option.value"
                                    class="matrix-choice__option"
                                    :style="{ width: `${100/selectOptions.length}%`}"
                                    :key="'option-'+i"
                                >
                                </b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                </b-col>
            </b-row>
        </div>

        <div class="matrix-choice__sm d-sm-none">
            <div class="matrix-choice__dropdown-row mb-4 px-3"
                v-for="(choice, i) in choices"
                :key="'choice-form-'+i"
            >
                <div class="matrix-choice__dropdown-label mb-2">
                    {{ $t(choice.text) }}
                </div>
                <b-form-select v-model="selected[i]">
                    <b-form-select-option :value="null" disabled hidden>
                        {{ $t(`${item.text}_DROPDOWN_PLACEHOLDER`) }}
                    </b-form-select-option>
                    <b-form-select-option v-for="(option, j) in selectOptions" :value="option.value" :key="'option-dd-'+j">
                        {{ option.text }}
                    </b-form-select-option>
                </b-form-select>
            </div>
        </div>
    </div>
</template>

<script>
import itemMixin from '@/components/mixins/itemMixin'
import colorVariantMixin from '@/components/mixins/colorVariantMixin'
import question from '@/components/ui/question'

export default {
    name: 'matrixChoiceItem',
    mixins: [
        itemMixin,
        colorVariantMixin
    ],
    components: {
        question
    },
    props: {
        item: {
            type: Object
        }
    },
    watch: {
        selected: {
            handler: function() {
                const results = this.selected.filter(result => result !== null)
                if(results.length === this.choices.length) {
                    const result = this.choices.map((choice, i) => ({
                        choice: choice.result,
                        result: this.selected[i]
                    }))

                    this.$emit('answer', result)
                }
            }
        }
    },
    data() {
        return {
            selected: []
        }
    },
    computed: {
        choices() {
            return this.item.choices
        },
        selectOptions() {
            const len = this.item.scale - this.item.scaleMin + 1
            return [...Array(len)].map((_,i) => {
                return {
                    value: i + 1,
                    text: this.scaleText(i+1, this.item.scale)
                }
            })
        }
    },
    methods: {
        injectCSSVariable() {
            return { '--base-color': this.baseColor };
        }
    },
    mounted() {
        const len = this.choices.length
        this.selected = [...Array(len)].map(_ => null)
    }
}
</script>
<style lang="scss">
.matrix-choice__md {
    @media screen and (max-width: 575px) {
        display: none;
    }
}

.matrix-choice__row {
    min-height: 35px;
}

.matrix-choice__row-label {
    width: 150px;
    font-size: 0.9rem;
}

@media screen and (max-width: 991px) {
    .matrix-choice__row-label {
        width: 120px;
    }
}

.matrix-choice__option {
    // width: 100px;
    margin-right: 0;
    display: inline-flex;
    justify-content: center;

    .custom-control-input:checked ~ .custom-control-label::before {
        border-color: var(--base-color) !important;
        background-color: var(--base-color) !important;
    }
}

.matrix-choice__option-label {
    font-size: 0.8rem;
    // width: 100px;
}

@media screen and (max-width: 767px) {
    .matrix-choice__row-label {
        // width: 100px;
        font-size: 0.9rem;
    }
}

@media screen and (max-width: 1199px) {
    .matrix-choice__option {
        // width: 70px;
        margin: 0 5px;
    }

    .matrix-choice__option-label {
        font-size: 0.7rem;
        // width: 70px;
        margin: 0 5px;
    }
}
</style>